import React, { FC } from 'react';
import {
  Card,
  Heading,
  SelectButton,
  SelectDynamicButton,
  TrevorIconName,
} from '@trevor/ui-components';
import styled from 'styled-components';
import { CONNECT_DATABASE_HOSTING_PROVIDER_TYPE } from '@/constants/test-ids';
import {
  hostingProviderOptions,
  isHostingProviderOtherSelected,
} from './utils';

const HostingProviderListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: var(--spacing-l);
`;

type DatabaseHostingProviderSelectorStepProps = {
  selectedValue: Maybe<string>;
  onSelect: F<string>;
  onOtherBlur: F0;
};
export const DatabaseHostingProviderSelectorStep: FC<
  DatabaseHostingProviderSelectorStepProps
> = ({ selectedValue, onSelect, onOtherBlur }) => {
  const isDynamicOptionSelected = isHostingProviderOtherSelected(selectedValue);

  return (
    <Card width="100%" alignItems="center" padding={32} gap={32}>
      <Heading variant={4}> Step 3: Your database hosting provider</Heading>
      <HostingProviderListContainer>
        {hostingProviderOptions.map((option) => (
          <SelectButton
            isFullWidth
            key={option.value}
            iconName={option.iconName as TrevorIconName}
            value={option.value}
            isSelected={selectedValue === option.value}
            onClick={() => onSelect(option.value)}
            data-testid={`${CONNECT_DATABASE_HOSTING_PROVIDER_TYPE}:${option.value}`}
          >
            {option.label}
          </SelectButton>
        ))}
        <SelectDynamicButton
          isFullWidth
          iconName="web"
          placeholder="Name of provider"
          label="Other"
          value={isDynamicOptionSelected && selectedValue ? selectedValue : ''}
          isSelected={isDynamicOptionSelected}
          onSelect={(value) => onSelect(value as string)}
          onBlur={onOtherBlur}
        />
      </HostingProviderListContainer>
    </Card>
  );
};
